// @flow
import axios from 'lib/defaultClient';
import queryString from 'query-string';

export type WriteQuotePayload = {
  title: string,
  body: string,
  is_temp: boolean,
  tags: Array<string>,
  categories: Array<string>,
  thumbnail: ?string,
  url_slug?: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const writeQuote = (payload: WriteQuotePayload) => axios.post('/quotes', payload);

export type UpdateQuotePayload = {
  id: string,
  title: string,
  body: string,
  tags: Array<string>,
  categories: Array<string>,
  url_slug?: ?string,
  thumbnail?: string,
  is_temp: boolean,
  thumbnail: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const updateQuote = ({ id, ...payload }: UpdateQuotePayload) =>
  axios.patch(`/quotes/${id}`, payload);

export type ReadQuotePayload = {
  username: string,
  urlSlug: string,
};

export const readQuote = ({ username, urlSlug }: ReadQuotePayload) =>
  axios.get(`/quotes/@${username}/${urlSlug}`);

export type UploadImagePayload = {
  file: any,
  quoteId: string,
  onUploadProgress(): void,
};

export const uploadImage = ({ file, quoteId, onUploadProgress }: UploadImagePayload) => {
  const data = new FormData();
  data.append('quote_id', quoteId);
  data.append('image', file);
  return axios.post('/files/upload/quote', data, {
    onUploadProgress,
  });
};

export type TempSavePayload = {
  title: string,
  body: string,
  quoteId: string,
};

export const tempSave = ({ quoteId, title, body }: TempSavePayload) =>
  axios.post(`/quotes/${quoteId}/saves`, { title, body });

export type CreateUploadUrlPayload = { quoteId: string, filename: string };
export const createUploadUrl = ({ quoteId, filename }: CreateUploadUrlPayload) => {
  return axios.post('/files/create-url/quote-image', { quote_id: quoteId, filename });
};

/* LISTING RELATED... */
export const getPublicQuotes = (cursor: ?string, category: ?string, sort: ?string) => {
  return axios.get('/quotes/public', {
    params: {
      cursor,
      category,
      sort,
    },
  });
};

export const getTrendingQuotes = (offset: ?number) => {
  const query = offset ? `?offset=${offset}` : '';
  return axios.get(`/quotes/trending${query}`);
};

export type GetUserQuotesPayload = {
  username: string,
  tag?: string,
  cursor?: string,
};

export const getUserQuotes = ({ username, cursor, tag }: GetUserQuotesPayload) => {
  const query = queryString.stringify({
    cursor,
    tag,
  });
  return axios.get(`/quotes/@${username}?${query}`);
};

export type GetPublicQuotesByCategoryPayload = {
  category: string,
  cursor?: string,
  sort?: string,
};

export const getPublicQuotesByCategory = (payload: GetPublicQuotesByCategoryPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/quotes/public?${query}`);
};

export type GetPublicQuotesByTagPayload = {
  tag: string,
  cursor?: string,
};

export const getPublicQuotesByTag = (payload: GetPublicQuotesByTagPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/quotes/public?${query}`);
};

export type GetTempQuotesPayload = {
  username: string,
  cursor?: string,
};

export const getTempQuotes = ({ username, cursor }: GetTempQuotesPayload) => {
  const query = queryString.stringify({
    is_temp: true,
    cursor,
  });
  return axios.get(`/quotes/@${username}?${query}`);
};

export const deleteQuote = (quoteId: string) => {
  return axios.delete(`/quotes/${quoteId}`);
};

export const getQuoteById = (quoteId: string) => {
  return axios.get(`/quotes/${quoteId}`);
};

export const getQuoteSequences = (quoteId: string) => {
  return axios.get(`/quotes/sequences?quote_id=${quoteId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/quotes/index.js